import { useAdministrativeContext } from '../../../../../../pages/administrativePanel/administrativePanelContext'
import { useState, useEffect, useCallback } from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts'
import { SpaceLoader } from '../../../../../loaders/spaceLoader'
import { useAuth } from '../../../../../../context/AuthContext'
import { formatMoney } from '../../../../../../Utils/formatMoney'
import { toast } from 'react-toastify'
import { api } from '../../../../../../services/api'

import { TooltipContent } from './style'


export function MonthlyBalance({ setIsMonthBalance }) {
    const [monthlyBalance, setMonthlyBalance] = useState([])
    const [isLoading, setIsLoading] = useState(true)
  
  
    const { 
      listBusinessToFilter, 
      startDate, 
      endDate,
      listSalesChannelsId 
    } = useAdministrativeContext()
  
    const { signOut } = useAuth()
  
    const fetchData = useCallback(async () => {
        setIsLoading(true)
        let obj = {
          startDate: startDate,
          endDate: endDate,
          business: listBusinessToFilter,
          salesChannels: listSalesChannelsId
        }
     
        try{
            await api.post('/getBalance' , obj, {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            }).then(response => setMonthlyBalance(response.data))
  
            setIsLoading(false)
  
        }catch(error){
            if(error.response){
                if(error.response.status === 401 || error.response.status === 500){
                  signOut()
                  toast.warning('Sua sessão foi expirada')
                }else{
                  toast.error(error.response.data.message)
                }
            }else{
                toast.error(error.message)
            }        
        }
    }, [signOut, endDate, startDate, listBusinessToFilter, listSalesChannelsId])
  
    
    useEffect(() =>{
      if(startDate !== '' && endDate !== '')
        fetchData()
  
        return () => {
            setMonthlyBalance([])
        }
  
    }, [fetchData, startDate, endDate])


    function openMonthBalance(e) {
      setIsMonthBalance({ visible: true, month: e.month })
    }

    function openMonthLastYearBalance(e){
      setIsMonthBalance({ visible: true, month: e.monthLastYear })
    }

    function renderTextLegend(value, entry){
      //console.log(entry)
      const {dataKey} = entry;
      return (
        <span>{dataKey === 'creditsMonthLastYear' ? 'Mês/Ano Passado' : 'Mês/Ano Atual'} <br/> </span>
        )
    }


    if(isLoading)
        return  <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)"/> 
     
    return(
      <>
        {
          monthlyBalance.length > 0 ?
            <ResponsiveContainer  width="98%" height="92%" maxHeight={700}>

                    <BarChart 
                      data={monthlyBalance} 
                      margin={{top: 30}}
                    >

                        
                        <Tooltip  
                            content={<CustomTooltip />}
                        /> 
                        
                        

                        <XAxis 
                          dataKey="month" 
                          axisLine={false} 
                          tickLine={false} 
                          stroke="var(--colorFontsCardsDashboard)" 
                          fontSize="0.75rem" 
                        />

                        <YAxis 
                            axisLine={false} 
                            tickLine={false} 
                            tickCount={6} 
                            width={65}
                            fontSize="0.85rem" 
                            stroke="var(--colorFontsCardsDashboard)" 
                            tickFormatter={number => (
                                number >= 1000 && number < 1000000 ? `R$${number/1000}K` : 
                                number >= 1000000 && number < 1000000000 ? `R$${number/1000000}M` :
                                number >= 1000000000 ? `R$${number/1000000000}B` :      
                                `R$${number.toFixed(2)}`
                            )} 
                        />

                        

                        <Bar 
                            onClick={openMonthLastYearBalance}
                            dataKey="creditsMonthLastYear" 
                            fill="#8884d8"  
                        />


                        <Bar 
                            onClick={openMonthBalance}
                            dataKey="credits" 
                            fill="#2e9699"  
                        />


                        <CartesianGrid 
                            opacity={0.2} 
                            vertical={false} 
                            stroke="var(--colorFontsCardsDashboard)" 
                        />

                        <Legend
                            iconSize={0}
                            layout='horizontal'
                            align='right'
                            verticalAlign='bottom'
                            formatter={renderTextLegend}
                        />

                    </BarChart>

            </ResponsiveContainer>
          :<p>Nenhuma informação</p>
        }
      </>
    )
}



export function CustomTooltip({ active, payload, label }) {
    if(active){
      return(
        <TooltipContent>

          {payload?.map((information, index) =>(
            <p key={index}>
             {information.name === 'creditsMonthLastYear' ? information.payload.monthLastYear : information.payload.month} - {formatMoney(information.value)}
            </p>
          ))}
          
        </TooltipContent>
      )
    }
    return null
  }
